<template>
  <div style="overflow: hidden">
    <b-modal
      id="modal-1"
      ref="Reg"
      title="Зарегистрироваться"
      @ok="register_submit"
      v-on:keyup.enter="register_submit"
      ok-only
      centered
      ok-variant="primary"
      ok-title="Зарегистрироваться"
      :hide-footer="true"
    >
      <b-form @submit.prevent="register_submit">
        <b-form-input
          v-model="register.email"
          type="email"
          placeholder="Email"
        ></b-form-input>
        <b-form-input
          v-model="register.password"
          type="password"
          placeholder="Пароль"
          class="mt-2"
        ></b-form-input>
        <b-form-input
          v-model="register.password2"
          type="password"
          placeholder="Повторить пароль"
          class="mt-2"
        ></b-form-input>
        <b-form-checkbox class="mt-2" v-model="agree">
          Я принимаю условия
          <a href="//skillslab.center/rules.htm" target="_blank"
            >пользовательского соглашения</a
          >
          и даю согласие на обработку моих
          <a href="//skillslab.center/politics.htm" target="_blank"
            >персональных данных</a
          >
        </b-form-checkbox>
        <b-button
          type="submit"
          variant="primary"
          class="mt-2"
          :disabled="!agree"
          >Зарегистрироваться</b-button
        >
        <div style="margin-top: 20px">или войдите с помощью:</div>
        <div style="font-size: 48px; color: #08a2dc" class="soc_auth mt-1">
          <img src="@/assets/vk.png" alt @click="social(1)" />
          <img src="@/assets/fb.png" alt @click="social(2)" />
        </div>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-2"
      title="Войти"
      @ok="login_submit"
      v-on:keyup.enter="login_submit"
      ok-only
      centered
      ok-variant="primary"
      ok-title="Войти"
      :hide-footer="true"
    >
      <b-form @submit.prevent="login_submit">
        <b-form-input v-model="login.email" placeholder="Email"></b-form-input>
        <b-form-input
          v-model="login.password"
          type="password"
          placeholder="Пароль"
          class="mt-2"
          v-if="!recover"
        ></b-form-input>
        <b-button type="submit" variant="primary" class="mt-2" v-if="!recover"
          >Войти</b-button
        >
        <b-button variant="primary" class="mt-2" v-else @click="recover_pass"
          >Восстановить</b-button
        >
        <p
          style="cursor: pointer; color: rgb(8, 162, 220)"
          class="mt-2"
          v-if="!recover"
          @click="recover = true"
        >
          Забыли пароль?
        </p>
        <p
          style="cursor: pointer; color: rgb(8, 162, 220)"
          class="mt-2"
          v-else
          @click="recover = false"
        >
          Войти?
        </p>
        <div style="margin-top: 20px">или войдите с помощью:</div>
        <div
          style="font-size: 48px; color: #08a2dc"
          class="soc_auth mt-1"
          v-if="!recover"
        >
          <img src="@/assets/vk.png" alt @click="social(1)" />
          <img src="@/assets/fb.png" alt @click="social(2)" />
        </div>
      </b-form>
    </b-modal>
    <header id="topnav" class="defaultscroll sticky">
      <div class="container">
        <div class="my_logo">
          <img src="@/assets/logo_ssl.png" class="mb-1 pt-1" />
          <a class href="index.html">Лаборатория переговоров</a>
        </div>

        <!-- Logo container-->

        <div class="buy-button">
          <a
            data-x
            target="_blank"
            class="btn btn-primary mr-2 d-none d-md-inline"
            role="button"
            v-b-modal.modal-1
            @click="reg_evt"
            >Зарегистрироваться</a
          >
          <a
            data-x
            target="_blank"
            class="btn btn-outline-primary d-none d-md-inline"
            role="button"
            v-b-modal.modal-2
            >Войти</a
          >
        </div>
        <!--end login button-->
        <!-- End Logo container-->

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul class="navigation-menu">
            <li>
              <a href="index.html" v-scroll-to="'#sim'">Программа</a>
            </li>
            <li>
              <a href="index.html" v-scroll-to="'#about'">О нас</a>
            </li>
            <li>
              <a href="index.html" v-scroll-to="'#sim'">Цены</a>
            </li>
          </ul>
          <!--end navigation menu-->
          <div class="buy-menu-btn d-none">
            <a
              data-x
              target="_blank"
              class="btn btn-primary"
              role="button"
              @click="reg_evt"
              v-b-modal.modal-1
              >Попробовать бесплатно</a
            >
            <a
              data-x
              target="_blank"
              class="btn btn-outline-primary ml-2"
              role="button"
              v-b-modal.modal-2
              >Войти</a
            >
          </div>
          <!--end login button-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>
    <!-- Hero Start -->
    <section class="section d-table w-100" style="margin-top: 50px">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7">
            <div class="title-heading">
              <h1 class="display-5 font-weight-bold mb-3">
                Первый онлайн-симулятор, который обучает решать конфликты и
                вести переговоры
              </h1>
              <p class="para-desc text-muted">
                Вы проживете множество конфликтных ситуаций, научитесь защищать
                свои границы, строить и применять стратегии.
              </p>
              <p class="para-desc text-muted">
                Тренажер-симулятор построен на авторских методиках Юрия и
                Александры Клименко
              </p>
              <div class="mt-4 pt-2">
                <a
                  href="javascript:void(0)"
                  class="btn btn-primary mt-2 mr-2"
                  role="button"
                  v-b-modal.modal-1
                >
                  Попробовать бесплатно
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-outline-primary mt-2"
                  role="button"
                  v-b-modal.modal-2
                  >Войти</a
                >
              </div>
            </div>
          </div>
          <!--end col-->
          <div
            class="col-lg-4 col-md-5 offset-lg-1 mt-4 pt-2 mt-sm-0 pt-sm-0 d-none d-md-block"
          >
            <div class="position-relative">
              <transition name="fade">
                <div class="message" v-if="order >= 0 && order < 3">
                  <div class="author">
                    <img src="../assets/avatars/1.png" alt />
                    <div class="info">
                      <div class="name">Иванова Аня (сокомандник)</div>
                    </div>
                  </div>
                  <div class="text">
                    Хорошо, что ты вовремя! Без капитана нам пришлось бы туго
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div class="message" v-if="order >= 1 && order < 3">
                  <div class="author">
                    <img
                      src="https://api.game.skillslab.center/media/avatars/avataaars_Jaur3hA.png"
                      alt
                    />
                    <div class="info">
                      <div class="name">Алексеев Иван (сокомандник)</div>
                    </div>
                  </div>
                  <div class="text">
                    Наконец-то! Ты понимаешь, что ставишь под угрозу все наши
                    усилия?
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div class="message" v-if="order >= 2 && order < 3">
                  <div class="author">
                    <img src="@/assets/question.svg" alt />
                    <div class="info">
                      <div class="name">Есть ли здесь конфликт?</div>
                    </div>
                  </div>
                  <div class="text" style="margin-top: 10px">
                    <div class="answer">Да</div>
                    <div class="answer">Нет</div>
                  </div>
                </div>
              </transition>

              <transition name="fade">
                <div class="message" v-if="order >= 4 && order < 8">
                  <div class="author">
                    <img
                      src="https://api.game.skillslab.center/media/avatars/avataaars_3.png"
                      alt
                    />
                    <div class="info">
                      <div class="name">Болотин Афанасий (крупный клиент)</div>
                    </div>
                  </div>
                  <div class="text">
                    Нужно ускорить сдачу проекта. Ваша юность ведь не
                    препятствие к тому, чтобы мотивировать команду сдать его на
                    две недели раньше?
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div class="message" v-if="order >= 5 && order < 6">
                  <div class="author">
                    <img src="@/assets/question.svg" alt />
                    <div class="info">
                      <div class="name">Какой тип конфликта?</div>
                    </div>
                  </div>
                  <div class="text" style="margin-top: 10px">
                    <div class="answer">Эмоциональный</div>
                    <div class="answer">Рациональный</div>
                    <div class="answer">Манипуляция</div>
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div class="message" v-if="order >= 7 && order < 8">
                  <div class="author">
                    <img src="@/assets/question.svg" alt />
                    <div class="info">
                      <div class="name">Как Вы ответите Афанасию?</div>
                    </div>
                  </div>
                  <div class="text" style="margin-top: 10px">
                    <b-form-textarea
                      id="write_answer"
                      no-resize
                      rows="4"
                      placeholder="Введите свой ответ сюда"
                    ></b-form-textarea>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <section class="section bg-light">
      
      <div class="container mb-4">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="section-title text-center">
              <h4 class="title">Для кого?</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>

      <div class="container mt-60">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="media align-items-center features">
              <div class="icons m-0 rounded h2 text-primary text-center px-2">
                <i class="las la-user-tie" style="color: rgb(8, 162, 220)"></i>
              </div>
              <div class="content ml-4">
                <h5 class="mb-1">
                  <div class="text-dark">Менеджерам и руководителям</div>
                </h5>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div class="media align-items-center features">
              <div class="icons m-0 rounded h2 text-primary text-center px-2">
                <i class="las la-briefcase" style="color: rgb(8, 162, 220)"></i>
              </div>
              <div class="content ml-4">
                <h5 class="mb-1">
                  <div class="text-dark">Предпринимателям и стартаперам</div>
                </h5>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="media align-items-center features">
              <div class="icons m-0 rounded h2 text-primary text-center px-2">
                <i class="las la-sitemap" style="color: rgb(8, 162, 220)"></i>
              </div>
              <div class="content ml-4">
                <h5 class="mb-1">
                  <div class="text-dark">Фасилитаторам и организаторам</div>
                </h5>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-3 col-md-6 col-12 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="media align-items-center features">
              <div class="icons m-0 rounded h2 text-primary text-center px-2">
                <i class="las la-users" style="color: rgb(8, 162, 220)"></i>
              </div>
              <div class="content ml-4">
                <h5 class="mb-1">
                  <div class="text-dark">Всем, кто хочет уметь эффективно коммуницировать</div>
                </h5>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end col-->
      </div>
      <!--end row-->
      <div class="container mt-100">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-60">
              <h4 class="title mb-4">Отзывы клиентов</h4>
              <p class="text-muted para-desc mb-0 mx-auto">
                Для нас важен результат, получаемый учениками
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row justify-content-center">
          <div class="col-lg-12 text-left" style="position: relative">
            <div class="right_carousel"></div>
            <carousel
              :items="windowHeight > 700 ? 2 : 1"
              :nav="false"
              :margin="40"
              :loop="true"
            >
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/5.png"
                  class="img-fluid avatar avatar-small rounded-pill shadow mb-2"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary text-left">
                  <a
                    href="https://www.facebook.com/tim.vetluzhsky.5/"
                    target="_blank"
                    >Нуриев Артём</a
                  >
                  <small class="text-muted">
                    Head of Product Management Газпром Медиа</small
                  >
                </h6>

                <p class="h6 text-left">
                  Хочу с вами поделиться эмоциями от проекта, про который
                  совершенно случайно узнал. Это что-то новенькое и необычное, а
                  главное тут нужная и полезная информация. Большинство из нас
                  сталкиваются с ситуациями, на работе, дома, в магазине, где
                  вами пытаются манипулировать, когда назревает конфликт, вам
                  необходимо отстоять свою точку зрения и многое другое. Это
                  Первый онлайн-симулятор, который обучает решать конфликты и
                  вести переговоры. Все происходит в игровой форме, когда вам
                  представляют реальные ситуации из жизни, где вам приведут
                  примеры, как с этим необходимо работать и как себя вести.
                  После прохождения симулятора у меня на многое открылись глаза,
                  это действительно очень крутая идея и повторюсь, очень
                  полезная.
                </p>
              </div>
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/1.png"
                  class="img-fluid avatar avatar-small rounded-pill shadow mb-2"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary text-left">
                  <a
                    href="https://www.facebook.com/tim.vetluzhsky.5/"
                    target="_blank"
                    >Тимофей</a
                  >
                  <small class="text-muted"> Product Owner Билайн</small>
                </h6>

                <p class="h6 text-left">
                  Симулятор меня сразу захватил. Ты невольно погружаешься в мир
                  героев, что почти забываешь где реальность, а где вымысел, тем
                  более последнего практически нет. Все кейсы очень практичные и
                  взяты из повседневной жизни. Самое интересное, что примеров
                  настолько много, что дух захватывает. Волей-неволей, ты
                  начинаешь правильно отвечать и осваивать премудрость ведения
                  переговоров. Я даже стал выявлять,а главное нейтрализовывать
                  манипуляторов! Это круто, ребята, спасибо!!!
                </p>
              </div>
              <div class="customer-testi">
                <img
                  src="@/assets/testimonials/2.png"
                  class="img-fluid avatar avatar-small rounded-pill shadow mb-2"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary text-left">
                  <a
                    href="https://www.facebook.com/konstantin.homchenko"
                    target="_blank"
                    >Хомченко Константин</a
                  >
                  <small class="text-muted"> Chili-маркетинг</small>
                </h6>
                <p class="h6 text-left">
                  Не дают повышения? Клиенты выжимают скидки? Поставщики
                  заламывают цены? Мама не покупает CD твоей любимой группы?
                  Токсичные коллеги отпускают о тебе шутки? Сотрудники пытаются
                  спихнуть на тебя ответственность? Приятель публично пытается
                  тебя задеть? Босс хочет трогать тебя там, где обычно
                  показывают на кукле? Ты рыжий, и все это замечают вслух? Тебе
                  поможет ч̶у̶д̶о̶-̶к̶р̶е̶м̶ симулятор конфликтных и переговорных
                  ситуаций от Юрия и Александры Клименко. В итоге я прошел 325
                  заданий за примерно 65 часов. Выучил и отработал кучу полезных
                  приемов и впитал море полезной информации. Именно впитал - за
                  таким методом изучения информации будущее. Очень крутая форма
                  подачи материала. Особенно оценят любители поучительного
                  повествования с героями - как в "Цель" Голдратта. Или как в
                  "Большой перемене" Константина Харского. Обе книги я тоже
                  настоятельно рекомендую прочитать. Первая глава бесплатная -
                  сразу поймешь, тебе подходит или нет.
                </p>
              </div>
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/3.png"
                  class="img-fluid avatar avatar-small rounded-pill mb-2 shadow"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary text-left">
                  <a href="https://www.facebook.com/m.arefieva" target="_blank"
                    >Марина Арефьева</a
                  >
                  <small class="text-muted">
                    Предприниматель, Сооснователь cmindconsulting.ru</small
                  >
                </h6>
                <p class="h6 text-left">
                  Ничего не предвещало, я досмотрела Дивный Новый Мир и вроде
                  нашла новый фильм, налила себе вина и села смотреть. Но фильм
                  оказался скучным, и я чисто рефлекторно начала просматривать
                  почту. Обнаружив там уведомление к новым комментариям по курсу
                  "Симулятор переговоров" Александры Клименко, я выключила
                  скучное кино, включила фоновую музыку, и прям так, с вином,
                  пошла разбирать комментарии других участников на ответы
                  первого модуля. Потом вспомнила, что мне же доступны и
                  остальные. И начала погружаться. Такой реалистичности я не
                  видела давно. Как-будто я снова работаю молодым проектным
                  менеджером в Яндексе и решаю задачи коммуникаций. Конечно,
                  описанные в симуляторе проблемы более токсичны, чем то, что
                  мне довелось пережить, заняв в 23 года позицию проектного
                  менеджера, но по духу очень реалистично. Разборы других
                  участников читать действительно интересно. В общем, прощайте,
                  я снова учиться, надо в симуляторе догонять, там уже 8 глав.
                  P.S. И почему я так часто ошибаюсь в ответах на задания этого
                  курса?
                </p>
              </div>
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/4.png"
                  class="img-fluid avatar avatar-small mb-2 rounded-pill shadow"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary">
                  <a
                    href="https://www.facebook.com/profile.php?id=100026386909393"
                    target="_blank"
                    >Алёна Серова</a
                  >
                  <small class="text-muted"> Project Manager</small>
                </h6>
                <p class="h6 text-left">
                  Я учусь в ВШЭ на программе Мировая экономика, интересуюсь
                  финансами, но в большей степени я маркетолог и менеджер.
                  Прошла годовой курс digital маркетинга в Бизнес в стиле .RU
                  (небольшая веб-студия). Сейчас там же курирую весь отдел
                  маркетинга, и в качестве project менеджера веду несколько
                  проектов. Планирую и дальше развиваться в сторону маркетинга,
                  project и product менеджмента! Переговорами стала
                  интересоваться с увеличением количества человек в команде
                  проекта и количества проектов на ведении. И с заказчиками
                  бывали сложности, и в команде без конфликтов не обходилось.
                  Еще одна большая проблема, знакомая как мне кажется многим
                  студентам, это периодические конфликты с родителями из-за
                  пропущенных пар и раннего начала развития карьеры. В
                  симуляторе очень понравился формат и систематизированная
                  теория (это то, чего так не хватает для развития soft skills)!
                  Решила, что мне это определенно надо! Не пожалела! Симулятор
                  оправдал все ожидания и даже больше! Особенно приятно, что
                  есть и чат, и группа в facebook, где всегда можно задать
                  сложный вопрос и получить ответ, объяснение и поддержку.
                  Приятным бонусом еще стали практические занятия, которые
                  проводятся примерно раз в неделю. Все понятно и очень
                  интересно! Классный продукт, успехов и развития ему!
                </p>
              </div>
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/6.png"
                  class="img-fluid avatar avatar-small mb-2 rounded-pill shadow"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary">
                  <a
                    href="https://www.facebook.com/profile.php?id=100026386909393"
                    target="_blank"
                    >Андрей Ульянов</a
                  >
                  <small class="text-muted"> СЕО Ketchup</small>
                </h6>
                <p class="h6 text-left">
                  Классный симулятор по выстраиванию личных и корпоративных
                  границ. Большинство ситуаций в симуляторе читал с мыслью как
                  это вообще возможно. Я такого раньше не встречал. И похоже был
                  страшным везунчиком в этом. Сексизмы, эйджизмы и прочие
                  приписывания, которые могут даже не восприниматься как
                  нарушения из-за нашего культурного бекграунда. Про защиту
                  личных границ. Когда тобой пытаются манипулировать, а в случае
                  неправильных ответов, ты и сам остаёшься виноватым в ситуации
                  перед коллективом. Про то что будет если не отрабатывать
                  эмоциональную реакцию другого человека. Эмпатия наше всё.
                  Множество приемов и всё аккуратно и поэтапно раскладывается по
                  полочкам. Очень ценно что вместе с теорией есть практические
                  занятия, на которых встаёт на место материал в голове.
                  Отличное предложение по соотношению стоимости и пользы.
                  Готовьте своё время, его потребуется много!
                </p>
              </div>
              <div class="customer-testi text-left">
                <img
                  src="@/assets/testimonials/7.png"
                  class="img-fluid avatar avatar-small mb-2 rounded-pill shadow"
                  style="width: auto !important"
                  alt
                />
                <h6 class="text-primary">
                  <a
                    href="https://www.facebook.com/profile.php?id=100026386909393"
                    target="_blank"
                    >Александр Птахин</a
                  >
                  <small class="text-muted"> Тимлид команды в SOVA.ai</small>
                </h6>
                <p class="h6 text-left">
                  Я занимаюсь переговорами уже больше двух лет и всегда ищу
                  способы проапгрейдить свои скилы в этой сфере. Симулятор Юры и
                  Саши помог уложить по полочкам в голове многие знания, которые
                  я уже получила за это время, а также более глубоко “капнуть” в
                  уже известные мне моменты. В огромный плюс курса -- теория. В
                  каждой из глав она очень емко описывает “тему урока”. При
                  этом, всё прохождение симулятора проходит в супер
                  захватывающей манере: при прохождении каждой из глав я
                  пропадала из всего остального мира на пару часов. Каждый раз
                  интересно узнать, куда приведет ответ, который ты дал на
                  конфликтную фразу, что произойдет в сюжете далее, или же как
                  ответили другие игроки. Этот симулятор отлично подойдет как
                  тем, кто уже интересовался изучением софт скиллов, так и тем,
                  кому слова “социальная роль” слышатся впервые. Мне повезло
                  жить и работать в среде, где манипуляторов и просто не очень
                  хороших людей мало, при этом я понимаю, что после прохождения
                  симулятора я стала чувствовать себя сильно уверенней при
                  общении с незнакомыми и малознакомыми людьми, ведь в случае
                  чего, я понимаю, как вести себя с манипуляторами и
                  обрабатывать возникающие конфликты. Мне, как продуктовому
                  аналитику в большой компании, этот скилл очень и очень
                  полезен: иногда за день проходят переговоры с десятками людей
                  и вы все заинтерсованы в одном -- сделать продукт лучше, а для
                  этого важно друг друга слушать, слышать, принимать критику и
                  чужие идеи, и всем вместе создавать крутой результат. Думаю,
                  это невозможно без софт скиллов.
                </p>
              </div>
            </carousel>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title">Чему вы научитесь?</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="media features pt-4 pb-4">
              <div
                class="icon text-center rounded-circle text-primary mr-3 mt-2"
              >
                <i
                  class="las la-fire"
                  style="
                    font-size: 28px;
                    padding-top: 7px;
                    color: rgb(8, 162, 220);
                  "
                ></i>
              </div>
              <div class="media-body">
                <h4 class="title-2">Решать конфликты</h4>
                <p class="text-muted mb-0">
                  Вы научитесь видеть проблемы взаимоотношений, их причины и
                  последствия. Будете знать, как правильно действовать в
                  конфликтной ситуации.
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-md-6 col-12">
            <div class="media features pt-4 pb-4">
              <div
                class="icon text-center rounded-circle text-primary mr-3 mt-2"
              >
                <i
                  class="las la-user-shield"
                  style="
                    font-size: 28px;
                    padding-top: 7px;
                    color: rgb(8, 162, 220);
                  "
                ></i>
              </div>
              <div class="media-body">
                <h4 class="title-2">Противодействовать манипуляциям</h4>
                <p class="text-muted mb-0">
                  Станете видеть и защищать свои границы в рабочих и личных
                  отношениях. Пресечете манипуляции на работе и дома.
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-md-6 col-12">
            <div class="media features pt-4 pb-4">
              <div
                class="icon text-center rounded-circle text-primary mr-3 mt-2"
              >
                <i
                  class="las la-handshake"
                  style="
                    font-size: 28px;
                    padding-top: 7px;
                    color: rgb(8, 162, 220);
                  "
                ></i>
              </div>
              <div class="media-body">
                <h4 class="title-2">Вести переговоры</h4>
                <p class="text-muted mb-0">
                  Научитесь оценивать ситуацию, видеть свои и чужие интересы,
                  сильные и слабые стороны. Сможете управлять течением
                  переговоров, двигать их к своей цели
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->
          <div class="col-md-6 col-12">
            <div class="media features pt-4 pb-4">
              <div
                class="icon text-center rounded-circle text-primary mr-3 mt-2"
              >
                <i
                  class="las la-level-up-alt"
                  style="
                    font-size: 28px;
                    padding-top: 7px;
                    color: rgb(8, 162, 220);
                  "
                ></i>
              </div>
              <div class="media-body">
                <h4 class="title-2">Коммуницировать на уровень выше</h4>
                <p class="text-muted mb-0">
                  Разовьете эмпатию, научитесь доносить свою мысль и лучше
                  понимать собеседника. Раскроете навыки фасилитации,
                  самопрезентации и позиционирования
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
      </div>
    </section>
    <section class="pt-5 pb-5 border-bottom border-top">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title">СМИ О НАС</h4>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-4">
          <div class="col-lg-2 col-md-2 col-6 text-center mt-4 mt-sm-0">
            <a href="https://snob.ru/entry/195159/" target="_blank">
              <img
                src="@/assets/snob.png"
                class="avatar avatar-ex-sm"
                alt
                style="cursor: pointer"
              />
            </a>
          </div>
          <!--end col-->
          <div class="col-lg-2 col-md-2 col-6 text-center mt-4 mt-sm-0">
            <a
              href="https://pro.rbc.ru/demo/5f16ac8a9a7947240f838562"
              target="_blank"
            >
              <img
                src="@/assets/rbk.png"
                class="avatar avatar-ex-sm"
                alt
                style="cursor: pointer"
              />
            </a>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
      <div class="container pb-5 mb-md-5 mt-100 mt-60">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <div class="saas-feature-shape-left position-relative">
              <img
                src="@/assets/cert_ex.jpg"
                class="img-fluid mx-auto d-block shadow"
                alt
              />
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="section-title ml-lg-4">
              <h1 class="title mb-3" style="line-height: 1.2">
                Сертификат за прохождение симулятора
              </h1>
              <p class="para-desc text-muted">
                Пройдите все уроки и получите сертификат, который вы сможете
                подтвердить по уникальной ссылке.
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      
    </section>
    <section class="section bg-light">
      <div class="container mb-4">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="section-title text-center">
              <h4 class="title">Чем симулятор лучше книги? А вебинара?</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-12">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img
                  src="../assets/icon/chat.svg"
                  class="avatar avatar-small"
                  alt
                />
              </div>

              <div class="content mt-4">
                <h4 class="title-2">Обучит на кейсах</h4>
                <p class="text-muted mb-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Более 300 заданий в одном сюжете
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Более 100 часов прохождения
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Практика решения конфликтов, противодействия манипуляциям,
                  подготовки стратегии и проведения переговоров.
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-4 col-12 mt-5 mt-sm-0">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img
                  src="@/assets/icon/customer-service.svg"
                  class="avatar avatar-small"
                  alt
                />
              </div>

              <div class="content mt-4">
                <h4 class="title-2">Даст обратную связь</h4>
                <p class="text-muted mb-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Комментарии ответов от других игроков
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Возможность получить фидбек от авторов
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Группа в фейсбуке и чат в телеграме для вопросов по симулятору
                </p>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-md-4 col-12 mt-5 mt-sm-0">
            <div class="features">
              <div class="image position-relative d-inline-block">
                <img
                  src="@/assets/icon/graduation-hat.svg"
                  class="avatar avatar-small"
                  alt
                />
              </div>

              <div class="content mt-4">
                <h4 class="title-2">Научит по авторской методике</h4>
                <p class="text-muted mb-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Типизация конфликтов и манипуляций
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Шаблоны и схемы ответа на конфликт
                  <br />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-check-circle fea icon-sm text-success mr-2"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Алгоритм подготовки к переговорам и авторские переговорные
                  приемы
                </p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
    </section>
    <section class="section" id="sim">
      <!--Program Section Start-->
      <div class="container">
        <div class="row">
          <!-- Main Course Start -->
          <div class="col-12">
            <div class="row">
              <div class="col-12 mb-4 pb-2">
                <div class="card blog rounded border-0 shadow overflow-hidden">
                  <div class="row align-items-center no-gutters">
                    <div class="col-md-3">
                      <img src="@/assets/cover.jpg" class="img-fluid" alt />
                    </div>
                    <!--end col-->

                    <div class="col-md-6">
                      <div class="card-body content">
                        <h4>
                          Первый онлайн-симулятор, который обучает решать
                          конфликты и вести переговоры
                        </h4>
                        <p class="text-muted mb-0">
                          Более 100 часов теории и практики конфликтов и
                          переговоров
                        </p>
                      </div>
                    </div>
                    <!--end col-->
                    <div class="col-lg-3 col-md-3 col-12 pr-4">
                      <div class="payment_block">
                        <div class="value text-md-right text-left">20000 ₽</div>
                        <button
                          data-v-041e2bbb
                          data-v-26ae368e
                          type="button"
                          class="btn btn-primary float-md-right mt-md-0 mt-1"
                          v-b-modal.modal-1
                        >
                          Попробовать бесплатно
                        </button>
                      </div>
                    </div>
                  </div>
                  <!--end row-->
                </div>
                <!--end main course-->
              </div>
              <!--end col-->
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-12 text-center">
                    <div class="section-title">
                      <h4 class="title">Программа</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      1
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Основы конфликтов</h4>
                    <p class="text-muted mb-0">
                      Вводная глава, где Вы познакомитесь с механикой
                      Симулятора. Работу над навыками soft skills мы начнем с
                      изучения природы конфликтов. Мы узнаем, почему конфликты
                      возникают, какими они бывают. Научимся видеть скрытые
                      конфликты в рабочих и личных отношениях, узнаем, как
                      реагировать на всплеск эмоций собеседника.

                      <br /><br />Изучив, какими бывают конфликты, Вы станете
                      лучше понимать, как работают взаимоотношения и
                      коммуникации.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      2
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Обработка конфликтов</h4>
                    <p class="text-muted mb-0">
                      В этой главе мы рассмотрим алгоритм того, как
                      анализировать конфликтную ситуацию, на что опираться в
                      своем ответе, как отвечать в случае агрессии.

                      <br /><br />Вы научитесь выяснять причину конфликта,
                      экологично реагировать и разрешать его, а также
                      использовать конфликт, как возможность улучшить
                      коммуникацию: в команде, с подчиненными или с клиентами.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      3
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Манипуляции</h4>
                    <p class="text-muted mb-0">
                      Манипуляции — одно из самых неприятных человеческих
                      проявлений. В этой главе мы подробно разберем то, какими
                      бывают манипуляции, как действует манипулятор и чего он
                      добивается от своей жертвы. Затем изучим действенные
                      приемы для борьбы с ними.

                      <br /><br />Вы научитесь выявлять манипуляции в рабочих и
                      личных отношениях, пресекать манипулятивное поведение,
                      экологично отстаивать свои границы на работе и в личной
                      жизни.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      4
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Анализ переговорной ситуации</h4>
                    <p class="text-muted mb-0">
                      От конфликтов и манипуляций переходим к переговорам. В
                      этой главе мы разберем, как проводить всесторонний анализ
                      ситуации до переговоров.. Мы будем искать проблемы в
                      ситуации, строить причинно-следственную связь, продумывать
                      последствия действий обеих сторон и формировать решения.

                      <br /><br />Это позволит Вам при возникновении проблем
                      проводить анализ для выявления причин и последствий. Вы
                      научитесь приоритизировать проблемы и продумывать решения,
                      действительно эффективно работающее для текущей ситуации.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      5
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">
                      Построение своей картины мира в переговорах
                    </h4>
                    <p class="text-muted mb-0">
                      Переговоры — это всегда взаимодействие с другой стороной.
                      В этой главе мы рассмотрим, как эффективно излагать свою
                      точку зрения на переговорах. Мы познакомимся с приемами
                      построения своей картины мира, донесения своих интересов
                      собеседнику — так, чтобы это давало Вам преимущество в
                      переговорах.

                      <br /><br />Пройдя эту главу, Вы научитесь
                      аргументировать, эффективно формулировать свою позицию и
                      цели.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      6
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Эмоции в переговорах</h4>
                    <p class="text-muted mb-0">
                      В этой главе Вы узнаете, что делать с нерациональным в
                      переговорах и как правильно говорить о своих эмоциях.
                      Узнаем, какие последствия будут, если эмоции игнорировать,
                      и как выражать собственные эмоции экологично.

                      <br /><br />Прохождение этой главы поможет улучшит Ваши
                      навыки эмоционального интеллекта, научит улучшать
                      отношения в работе и личной жизни с помощью проявления
                      эмпатии.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      7
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">
                      Приемы получения информации на переговорах
                    </h4>
                    <p class="text-muted mb-0">
                      В этой главе Вы будете учиться получать информацию от
                      собеседника. Мы научимся отделять оценки от фактов,
                      выяснять истинную точку зрения и интересы другой стороны.

                      <br /><br />После прохождения этой главы Вы научитесь
                      располагать к себе собеседника, узнаете, чем плох вопрос
                      «почему» и научитесь верифицировать полученную информацию.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      8
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">
                      Приемы обработки чужой картины мира в переговорах
                    </h4>
                    <p class="text-muted mb-0">
                      Эта глава посвящена тому, как изменить мнение собеседника
                      и превратить его из оппонента в союзника. Вы узнаете, как
                      обрабатывать ошибочные суждения и аргументы собеседника,
                      менять его взгляды и позиции.

                      <br /><br />Вы научитесь анализировать аргументы
                      собеседника, находить слабости и ошибки, выводить
                      переговоры из тупика, экологично направлять разговор в
                      конструктивное русло.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      9
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Стратегия в переговорах</h4>
                    <p class="text-muted mb-0">
                      Эта глава посвящена подготовке стратегии переговоров. Вы
                      узнаете, какие приемы можно планировать заранее, как
                      просчитать, куда заведут переговоры, когда и каким образом
                      предлагать решения в переговорах.

                      <br /><br />Вы выведете анализ ситуации на новый уровень,
                      научившись прогнозировать развитие переговоров до их
                      начала, находить ключевые точки и использовать
                      стратегические приемы.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-10 col-12">
                <div class="media features pt-4 pb-4">
                  <div
                    class="icon text-center rounded-circle text-primary mr-3 mt-2"
                  >
                    <p
                      style="
                        font-size: 20px;
                        padding-top: 7px;
                        font-weight: 800;
                        color: rgb(8, 162, 220);
                      "
                    >
                      10
                    </p>
                  </div>
                  <div class="media-body">
                    <h4 class="title-2">Практика конфликтов и переговоров</h4>
                    <p class="text-muted mb-0">
                      В этой главе — еще больше кейсов. Вы сможете закрепить
                      изученные ранее приемы из области решения конфликтов,
                      противодействия манипуляциям и ведения переговоров.
                    </p>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end col-->
      <!-- Program section end -->
    </section>
    <section class="section" id="about">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="card team text-center border-0">
              <div class="position-relative">
                <img
                  src="@/assets/author_yuri.png"
                  class="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt
                />
                <ul class="list-unstyled social-icon team-icon mb-0 mt-4">
                  <li class="list-inline-item">
                    <a href="https://fb.com/Klimenkoyuri" class="rounded">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-facebook fea icon-sm fea-social"
                      >
                        <path
                          d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="card-body py-3 px-0 content">
                <h5 class="mb-0">
                  <a href="javascript:void(0)" class="name text-dark"
                    >Юрий Клименко</a
                  >
                </h5>
                <small class="designation text-muted">
                  Основатель и президент ассоциации переговорных клубов.
                  Кризис-консультант, профессиональный переговорщик.
                  Преподаватель курса переговоров в НИУ ВШЭ.
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card team text-center border-0">
              <div class="position-relative">
                <img
                  src="@/assets/author_alex.png"
                  class="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt
                />
                <ul class="list-unstyled social-icon team-icon mb-0 mt-4">
                  <li class="list-inline-item">
                    <a href="https://fb.com/alexanika" class="rounded">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-facebook fea icon-sm fea-social"
                      >
                        <path
                          d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="card-body py-3 px-0 content">
                <h5 class="mb-0">
                  <a href="javascript:void(0)" class="name text-dark"
                    >Александра Клименко</a
                  >
                </h5>
                <small class="designation text-muted"
                  >Предприниматель в сфере цифровых продуктов, автор проекта
                  «Нормально делай, нормально будет» о digital продуктах. Лучший
                  преподаватель факультета бизнеса и менеджмента НИУ ВШЭ</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="row">
        <!-- Main Course Start -->
        <div class="col-12">
          <div class="col-12 mb-4 pb-2">
            <div class="card blog rounded border-0 shadow overflow-hidden">
              <div class="row align-items-center no-gutters">
                <div class="col-md-3">
                  <img src="@/assets/cover.jpg" class="img-fluid" alt />
                </div>
                <!--end col-->

                <div class="col-md-6">
                  <div class="card-body content">
                    <h4>
                      Первый онлайн-симулятор, который обучает решать конфликты
                      и вести переговоры
                    </h4>
                    <p class="text-muted mb-0">
                      Более 100 часов теории и практики конфликтов и переговоров
                    </p>
                  </div>
                </div>
                <!--end col-->
                <div class="col-lg-3 col-md-3 col-12 pr-4">
                  <div class="payment_block">
                    <div class="value text-md-right text-left">20000 ₽</div>
                    <button
                      data-v-041e2bbb
                      data-v-26ae368e
                      type="button"
                      class="btn btn-primary float-md-right mt-md-0 mt-1"
                      v-b-modal.modal-1
                    >
                      Попробовать бесплатно
                    </button>
                  </div>
                </div>
              </div>
              <!--end row-->
            </div>
            <!--end main course-->
          </div>
        </div>
      </div>
    </div>
    <footer>
      <p style="text-align: center">
        ИП Клименко Александра Аркадьевна
        <br />ИНН: 772077460576 <br />ОГРНИП: 317774600515561 <br />Email:
        info@skillslab.center
        <br />
        <a href="//skillslab.center/rules.htm" target="_blank"
          >Пользовательское соглашение</a
        >
        <br />
        <a href="//skillslab.center/politics.htm" target="_blank"
          >Политика обработки персональных данных</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
import API from "@/api";
import carousel from "vue-owl-carousel";

export default {
  name: "Landing",
  components: { carousel },
  data: function () {
    return {
      order: 6.4,
      windowHeight: window.innerHeight,
      messages: [{}],
      disabled: false,
      menu: false,
      login: {
        email: "",
        password: "",
      },
      agree: false,
      recover: false,
      register: {
        email: "",
        password: "",
        password2: "",
      },
    };
  },
  mounted() {
    this.$gtag.pageview({
      page_path: "/landing",
    });
    if (this.$route.query.recover == "true") {
      this.$bvToast.toast("Теперь Вы можете войти", {
        title: "Успешно",
        variant: "success",
        solid: true,
      });
    }
    setInterval(
      function () {
        this.order = this.order + 1;
        if (this.order > 8) {
          this.order = 0;
        }
      }.bind(this),
      2000
    );
  },
  methods: {
    reg_evt() {
      window.fbq("track", "Lead");
      this.$gtag.event("try", {
        event_category: "register",
      });
    },
    recover_pass() {
      const data = new FormData();
      data.append("email", this.login.email);
      API.post("/api/request_password_change", data)
        .then((response) => {
          this.$bvToast.toast("Проверьте Вашу почту", {
            title: "Успешно",
            variant: "success",
            solid: true,
          });
        })
        .catch(
          function (error) {
            this.$bvToast.toast(
              "Если вы считаете, что это ошибка — свяжитесь с нами",
              {
                title: "Нет такой почты",
                variant: "danger",
                solid: true,
              }
            );
          }.bind(this)
        );
    },
    check_social(key, win) {
      var timer = setInterval(
        function () {
          const data = new FormData();
          data.append("key", key);
          API.post("/api/convert_token", data).then((response) => {
            if (response.data.status == 1) {
            }
            if (response.data.status == 2) {
              clearInterval(timer);
              win.close();
              this.$store.dispatch("social_login", {
                token: response.data.token,
              });
            }
          });
        }.bind(this),
        1000
      );
    },
    social(type) {
      const win = window.open("about:blank", "", "height=600,width=auto");
      win.document.write("Перенаправляем на авторизацию");
      API.post("/api/start_auth")
        .then((response) => {
          if (type == 1) {
            win.location.replace(
              "http://api.game.skillslab.center/login/vk-oauth2/?id=" +
                response.data.id
            );
            win.focus();
          } else {
            win.location.replace(
              "http://api.game.skillslab.center/login/facebook/?id=" +
                response.data.id
            );
            win.focus();
          }

          this.check_social(response.data.key, win);
        })
        .catch(
          function (error) {
            win.close();
            this.$bvToast.toast(
              "Что-то пошло не так. Свяжитесь с администратором",
              {
                title: "Ошибка при регистрации",
                variant: "danger",
                solid: true,
              }
            );
          }.bind(this)
        );
    },
    login_submit() {
      if (this.login.username == "" || this.login.password == "") {
        this.$bvToast.toast("Заполните все поля и повторите попытку", {
          title: "Не все поля заполнены",
          variant: "warning",
          solid: true,
        });
      } else {
        {
          this.$store.dispatch("login", {
            vm: this,
            username: this.login.email,
            password: this.login.password,
          });
        }
      }
    },
    register_submit() {
      this.disabled = true;
      this.$loading.show({ delay: 0 });
      this.disabled = false;

      if (
        this.register.email &&
        this.register.password2 != "" &&
        this.register.password != ""
      ) {
        if (this.register.password == this.register.password2) {
          const data = new FormData();
          data.append("email", this.register.email);
          data.append("password", this.register.password);
          data.append("username", this.register.email);

          API.post("api/signup/", data)
            .then(
              function (response) {
                this.$gtag.event("click", {
                  event_category: "register",
                });
                this.$store.dispatch("login", {
                  vm: this,
                  email: this.register.email,
                  password: this.register.password,
                  username: this.register.email,
                });
              }.bind(this)
            )
            .catch((e) => {
              this.disabled = false;
              this.$loading.hide();
              this.register = {
                email: "",
                password: "",
                password2: "",
              };
              this.$bvToast.toast(
                "Если вы считаете, что это ошибка – свяжитесь с нами",
                {
                  title: "Почта уже существует",
                  variant: "danger",
                  solid: true,
                }
              );
            });
        } else {
          this.$loading.hide();
          this.$bvToast.toast("Проверьте и введите еще раз", {
            title: "Пароли не совпадают",
            variant: "warning",
            solid: true,
          });
        }
      } else {
        this.$loading.hide();
        this.$bvToast.toast("Заполните все поля и повторите попытку", {
          title: "Не все поля заполнены",
          variant: "warning",
          solid: true,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url(../assets/landing/css/materialdesignicons.min.css);
@import url(../assets/landing/css/style.css);
@import url(../assets/landing/css/colors/default.css);
.question {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 5px;
  line-height: 20px;
  color: #2e2e2e;
}
.answer {
  background-color: white;
  width: 100%;
  padding: 4px 0;
  border-radius: 6px;
  font-family: Open Sans, sans-serif;
  font-weight: bold;
  text-align: center;
  color: #252525;
  border: 1px solid #b1b1b1;
  border-radius: 6px;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  margin-bottom: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
}
.my_logo a {
  color: black;
}
.my_logo img {
  display: table;
  width: 160px;
}
.my_logo {
  float: left;
  display: table;
  font-size: 13px;
}
#topnav {
  box-shadow: 1px 0 8px 3px rgba(0, 0, 0, 0.4);
  z-index: 100;
  background-color: white !important;
}
.messages {
  transition: all 0.5s;
}
.message {
  margin-top: 15px;
}
.author {
  display: table;
  width: 100%;
}
.author img {
  width: 35px;
  height: 35px;
  border-radius: 35px;
  float: left;
}
.author .info {
  float: left;
  margin-left: 5px;
  margin-top: 10px;
}
.name {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
}
.role {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-top: 5px;
}
.text {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  margin-left: 40px;
  color: #4f4f4f;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.c_name {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* or 122% */

  color: #000;
}
.c_description {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #777777;
}
.value {
  font-family: "Open Sans", "Nunito", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 44px;
  /* or 176% */

  text-align: center;

  color: #70baff;
}
.content-footer {
  color: white;
  background-color: #08a2dc;
  padding: 20px;
  text-align: center;
}
.content-footer.noactive {
  background-color: #eee;
  color: black;
  cursor: not-allowed !important;
}
.soc_auth img {
  width: 28px;
  float: left;
  margin-right: 5px;
  cursor: pointer;
}
.title {
  color: black !important;
}
.customer-testi p {
  padding: 20px 20px;
  background-color: #f1f1f1 !important;
}
.right_carousel {
  position: absolute;
  right: 0;
  top: 0;
  width: 150px;
  bottom: 0;
  z-index: 10;
  background: linear-gradient(
    to right,
    rgba(248, 249, 252, 0) 0%,
    rgba(248, 249, 252, 1) 60%
  );
}
@media (max-width: 375px) {
  #topnav .buy-button .btn {
    font-size: 14px;
    padding-left: 7px;
    padding-right: 7px;
  }
}
@media (max-width: 700px) {
  .right_carousel {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    bottom: 0;
    z-index: 10;
    background: linear-gradient(
      to right,
      rgba(248, 249, 252, 0) 0%,
      rgba(255, 255, 255, 1) 60%
    );
  }
}
</style>
